import(/* webpackMode: "eager" */ "/home/runner/work/devpath-ai/devpath-ai/app/rest/page.tsx");
